import PropTypes from 'prop-types';
import React from 'react';
import { ModelYear } from '@sm360/widget-commons-vehicle';
import { LocaleService } from '@sm360/widget-commons-core-services';

import FeatureIcon from 'build-and-quote/components/ModelTrims/ModelTrimFeatures/FeatureIcon.jsx';

import 'build-and-quote/components/Summary/components/VehicleCharacteristics/components/FeatureBlock.scss';

const FeatureBlock = ({ features, packageName }) => {
    return (
        <div className="feature-block">
            <p className="sr-text is-bold is-small feature-block-title">
                {packageName || LocaleService.t('summarySection.package')}
            </p>
            {features?.length ? (
                <ul className="features-list">
                    {features.map(
                        (featureIcon) =>
                            featureIcon.icon !== '' && (
                                <FeatureIcon
                                    key={featureIcon.icon}
                                    code={featureIcon.icon}
                                    description={featureIcon.description}
                                />
                            )
                    )}
                </ul>
            ) : (
                <div>{LocaleService.t('summarySection.no_features_available')}</div>
            )}
        </div>
    );
};

FeatureBlock.propTypes = {
    features: PropTypes.arrayOf(PropTypes.instanceOf(ModelYear.FeatureIcon)).isRequired,
    packageName: PropTypes.string.isRequired,
};

FeatureBlock.displayName = 'FeatureBlock';

export default FeatureBlock;
